const getResText = (error) => {
  const res = error.response;
  if (!res) return '';
  if (res.text) return res.text;
  if (res.body && typeof res.body === 'object') {
    try { return JSON.stringify(res.body); } catch (e) { return ''; }
  }
  return '';
};

const classifyError = (error) => {
  const errStr = String(error);
  const resText = getResText(error);
  if (errStr.includes('captcha-delivery.com') || resText.includes('captcha-delivery.com')) {
    return `DataDome captcha intercept (status: ${error.status || 'unknown'})`;
  }
  if (errStr.includes('<!doctype') || errStr.includes('<html')) {
    return `ESAPI html response (status: ${error.status || 'unknown'})`;
  }
  if (errStr.includes('Request has been terminated')) {
    return `Network error (status: ${error.status || 'unknown'})`;
  }
  return `${errStr} (status: ${error.status || 'unknown'})`;
};

const HEAVY_GEO_KEYS = ['nearby', 'geocircle', 'geobounds', 'geopolygon'];

const lightQObject = (qObj) => {
  if (!qObj) return qObj;
  const light = { ...qObj };
  HEAVY_GEO_KEYS.forEach((key) => {
    if (light[key]) light[key] = true;
  });
  return light;
};

const extractResponseInfo = (error) => {
  const res = error.response;
  if (!res) return null;
  const fullBody = getResText(error);
  const body = fullBody.length > 800
    ? fullBody.slice(0, 400) + '…' + fullBody.slice(-200)
    : fullBody;
  return {
    status: error.status,
    url: (res.req && res.req.url) || res.url || 'unknown',
    redirected: Array.isArray(res.redirects) && res.redirects.length > 0,
    body,
  };
};

const throwApireqDebugError = (pageName, error, locations, qObject) => {
  const hkeys = (locations || []).map(l => l.hkey).join(',');
  const errorSummary = classifyError(error);
  const qObjectStr = JSON.stringify(lightQObject(qObject));
  const responseInfo = extractResponseInfo(error);
  const responseStr = responseInfo ? JSON.stringify(responseInfo) : 'none';
  setTimeout(() => {    
    throw new Error(
      `[APIREQ_DEBUG - ${pageName}] computeAPIReq failed - error: ${errorSummary} - response: ${responseStr} - localities: ${hkeys} - qObject: ${qObjectStr}`,
    );
  }, 0);
};

export default throwApireqDebugError;
